import React, { useState } from 'react';
import moment from 'moment';
import { UserType } from 'src/views/user-management/model';
import {
  Card,
  CardContent,
  CardHeader,
  Switch,
  FormControlLabel,
  Button,
  CardActions,
  ButtonGroup,
  Typography,
  Box,
} from '@material-ui/core';
import { Formik, FieldArray, Field, Form } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';
import { useAuthContext } from 'src/context/AuthContext';
import { v4 as uuid } from 'uuid';
import { doc, setDoc } from 'firebase/firestore';
import { collection, query } from 'firebase/firestore';
import { useFirestoreCollectionData } from 'reactfire';
import { useFirestore } from 'reactfire';
import { useLocation } from 'react-router-dom';
import * as _ from 'lodash';

export const numberEmoji = [
  '1️⃣',
  '2️⃣',
  '3️⃣',
  '4️⃣',
  '5️⃣',
  '6️⃣',
  '7️⃣',
  '8️⃣',
  '9️⃣',
  '🔟',
  '⭐️',
];

interface templatePreviewType {
  group: number;
  date: string;
  attendanceItems: { name: string; time: string }[];
  showEditMode?: boolean;
  groupMembers?: UserType[];
}
export const TemplatePreview: React.VFC<templatePreviewType> = ({
  group,
  date,
  attendanceItems,
  groupMembers,
  showEditMode = false,
}) => {
  const [editMode, setEditMode] = useState(false);
  const { user } = useAuthContext();
  const db = useFirestore();

  const { pathname } = useLocation();
  const attendanceID = pathname.split('/')[pathname.split('/').length - 1];

  const attendanceAnswersQuery = query(
    collection(db, 'attendanceLists', attendanceID, 'answers')
  );
  const { data: attendanceListsData } = useFirestoreCollectionData(
    attendanceAnswersQuery,
    {
      idField: 'id', // this field will be added to the object created from each document
    }
  );
  const attendanceListsDataWithType = attendanceListsData as attendanceListsDataType[];

  // console.log('attendanceListsDataWithType',attendanceListsDataWithType.find(member=>member.name=user.name));
  return (
    <Formik
      initialValues={{
        attendanceItems: attendanceItems.map((attendanceQues) => {
          return {
            attendance: '',
            reason: '',
          };
        }),
      }}
      validationSchema={Yup.object().shape({
        attendanceItems: Yup.array()
          .of(
            Yup.object().shape({
              attendance: Yup.string().required('Required'),
              reasons: Yup.string(),
            })
          )
          .min(1),
      })}
      onSubmit={async (values) => {
        const { name, userId, telegramId } = user;
        const allData = {
          name,
          userId,
          telegramId,
          ...values,
        };
        const newUUID = uuid();
        await setDoc(
          doc(db, 'attendanceLists', attendanceID, 'answers', user.userId),
          allData
        );
        setEditMode(false);
      }}
      render={({ values, errors, touched, setFieldValue }) => (
        <Form>
          <Card>
            {showEditMode && (
              <CardHeader
                action={
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editMode}
                        onChange={() => setEditMode(!editMode)}
                        name="mode"
                        color="primary"
                      />
                    }
                    label={editMode ? 'Edit mode' : 'View mode'}
                  />
                }
                title={<strong>🗓 G{group} Attendance Check 🗓 </strong>}
                subheader={moment(date, 'DD-MM-YYYY').format('dddd DD/MM')}
              />
            )}

            <CardContent>
              {/* <pre> {JSON.stringify(values,null,2)}</pre> */}
              {showEditMode !== true && (
                <>
                  <strong>🗓 G{group} Attendance Check 🗓 </strong> <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;{' '}
                  {moment(date, 'DD-MM-YYYY').format('dddd DD/MM')} <br />
                </>
              )}
              <FieldArray
                name="attendanceItems"
                render={(arrayHelpers) => (
                  <>
                    {attendanceItems.map((attendance, idx) =>
                      attendance.name !== '' && attendance.time !== '' ? (
                        <>
                          <br />
                          <strong>
                            {numberEmoji[idx]} &nbsp;{attendance.name} <br />
                          </strong>
                          ⏰ Time: {attendance.time} <br />
                          {editMode && (
                            <>
                              <Box display="flex" gridGap={8} mt={1}>
                                <ButtonGroup
                                  size="small"
                                  aria-label="small outlined button group"
                                >
                                  {['✅', '⚠️', '❌'].map((option) => (
                                    <Button
                                      key={option}
                                      variant={
                                        values.attendanceItems[idx]
                                          .attendance === option
                                          ? 'contained'
                                          : 'outlined'
                                      }
                                      onClick={() =>{
                                        setFieldValue(
                                          `attendanceItems.${idx}.attendance`,
                                          option
                                        );
                                        // setFieldValue(
                                        //   `attendanceItems.${idx}.reason`,
                                        //   ''
                                        // );
                                      }
                                      }
                                    >
                                      {option}
                                    </Button>
                                  ))}
                                </ButtonGroup>
                                {['✅','⚠️', '❌'].includes(
                                  values.attendanceItems[idx].attendance || ''
                                ) && (
                                  <Field
                                    name={`attendanceItems.${idx}.reason`}
                                    component={TextField}
                                    required={['⚠️', '❌'].includes( values.attendanceItems[idx].attendance || '' )}
                                    variant="outlined"
                                    label={['⚠️', '❌'].includes( values.attendanceItems[idx].attendance || '' )?'Reason':'Note'}
                                    size="small"
                                    placeholder="e.g. 146 / 6:30pm"
                                  />
                                )}
                              </Box>
                              <Typography variant="caption" color="error">
                                {errors.attendanceItems !== undefined &&
                                  touched.attendanceItems !== undefined &&
                                  touched.attendanceItems[idx] &&
                                  errors.attendanceItems[idx] &&
                                  'required *'}
                              </Typography>
                            </>
                          )}
                          <br />
                        </>
                      ) : null
                    )}
                  </>
                )}
              />

              {!editMode && groupMembers && (
                <>
                  <br />
                </>
              )}
              {!editMode && !!groupMembers&&!!attendanceListsDataWithType && (
                <MemberAttendance
                  groupMembers={groupMembers}
                  attendanceID={attendanceID}
                  attendanceListsDataWithType={attendanceListsDataWithType}
                />
              )}
            </CardContent>
            {editMode && (
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                >
                  Save Changes
                </Button>
              </CardActions>
            )}
            
          </Card>
        </Form>
      )}
    />
  );
};

interface attendanceListsDataType {
  attendanceItems: {
    attendance: string;
    reason: string;
  }[];
  telegramId: string;
  userId: string;
  name: string;
  id: string;
}

interface MemberAttendanceType {
  groupMembers: UserType[];
  attendanceID: string;
  attendanceListsDataWithType:attendanceListsDataType[]
}

const usersDataOrderByGroup = (usersData:any) => _.uniqBy(_.orderBy(usersData, ['group', 'team','order'], ['asc', 'asc','asc']),'name') as UserType[];

const MemberAttendance: React.VFC<MemberAttendanceType> = ({
  groupMembers,
  attendanceID,
  attendanceListsDataWithType
}) => {
 
  const userOtherByGroup = usersDataOrderByGroup(groupMembers);
  const userGroupByTeam = _.groupBy(userOtherByGroup,'team');

  return (
    <>
      {Object.keys(userGroupByTeam).map(teamNumber=>{
        return (
          <>
            {userGroupByTeam[teamNumber].map((groupMember) => {
              const memberAnswer = attendanceListsDataWithType.find(
                (item) => item.name === groupMember.name
              );
              return (
                <div key={groupMember.name} style={{fontFamily:`'Segoe UI', 'Roboto', 'Oxygen',
          'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
          sans-serif`}}>
            
                  {groupMember.name} &nbsp;
                  {memberAnswer !== undefined &&
              memberAnswer.attendanceItems.map(
                (attendanceItem) => `${attendanceItem.attendance}${attendanceItem.reason} `
              )}
                  <br />
                </div>
              );
            })}
            <br/>
          </>);

      })}
  
    </>
  );
};
